module.exports = __webpack_public_path__ + "assets/1792649897182/img/audio-icon.4297b8a9.png";